
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../UserPermissions.js";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { StorageAccess, Permissions_allowsInStorage, Permission, Permissions_has } from "../../../Shared/Roles.js";
import { safeHash, equals, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, isNullOrWhiteSpace, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { NewCategoryDialog } from "../../../Widgets/Dialogs/NewCategoryDialog.js";
import { Msg } from "./Types.js";
import { empty, append, singleton, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { AreaAnchorMenu } from "../../../Widgets/AnchorMenu.js";
import { empty as empty_1, isEmpty, singleton as singleton_1, choose, contains, filter, map as map_1, tryFind, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { LabelId, BusinessUnitId__get_unwrap, StorageId__get_unwrap, FormState__isValid, FormState__getValidation } from "../../../Shared/Shared.js";
import { WarningAlert, InformationAlert, ErrorAlert } from "../../../Components/Alert.js";
import { FormMultipleImageSection, FormSection } from "../../../Widgets/FormSection.js";
import { Feature, isFeatureEnabled } from "../../../FeatureFlip.js";
import { CurrencyInput, Input, AutoSuggestInput } from "../../../Components/Input.js";
import { value as value_22, map, defaultArg, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { BusinessUnitSelect } from "../../../Widgets/BusinessUnitSelect.js";
import { MultiSelectWithColor, Select } from "../../../Components/Select.js";
import { Storage__get_DisplayName } from "../../../Shared/Storage.js";
import { unwrapToolId, unwrapStorageId } from "../../../Shared/Helper.js";
import { TextArea } from "../../../Components/TextArea.js";
import { Hierarchy_getAllCategoryIdsInHierarchy, Hierarchy_getDisplayName, Hierarchy_buildTreeOrderedList, Hierarchy_keepDeepestCategories } from "../../../Shared/Category.js";
import { parse } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Button, TextButton } from "../../../Components/Button.js";
import { QrCodeTable } from "../../../Widgets/Tables/QrCodeTable.js";
import { DatePicker } from "../../../Components/DatePicker.js";
import { NewInventoryCustomProperties } from "../../../Widgets/CustomProperties.js";
import { PrinzingSpecificForm } from "./CustomerSpecificView.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initNewToolModalView, initCopyNewTool, initNewToolView, update as update_1, initEditView } from "./State.js";
import Arrow_Left_1 from "../../../../public/assets/icons/Arrow_Left_1.svg";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { isCreateInventoryFormOnboardingTourPhase, getQueryParams } from "../../../Common.js";
import { PageHeader } from "../../../Components/Text.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../../Components/TourGuide.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";

export function ToolForm(props) {
    let elems_5, elems, elems_4, elems_3;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const patternInput_1 = reactApi.useState("master_data");
    const patternInput_2 = reactApi.useState(false);
    const setIsNewCateogoryDialogOpen = patternInput_2[1];
    const isCommercialDataVisible = Permissions_has(permissions, new Permission(30, []));
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,1fr]", "mt-12"])], (elems_5 = [createElement(NewCategoryDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsNewCateogoryDialogOpen(false);
            props.Dispatch(new Msg(24, []));
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = toList(delay(() => (props.WithAnchorMenu ? singleton(createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "master_data",
            Label: t("general.master_data"),
        }), delay(() => append(singleton({
            Id: "qr_codes",
            Label: t("general.qr_codes"),
        }), delay(() => append(singleton({
            Id: "appointments",
            Label: t("general.appointments"),
        }), delay(() => append(isCommercialDataVisible ? singleton({
            Id: "commercial_data",
            Label: t("tool.commercial_data"),
        }) : empty(), delay(() => (props.IsCustomPropertiesEnabled ? singleton({
            Id: "custom_properties",
            Label: t("tool.custom_properties"),
        }) : empty()))))))))))),
        OnSelectAnchor: patternInput_1[1],
        SelectedAnchor: patternInput_1[0],
    })) : empty()))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "max-w-5xl"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-9"])], (elems_3 = toList(delay(() => {
        let matchValue_1;
        return append((matchValue_1 = FormState__getValidation(props.FormState, t, "global"), (matchValue_1 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
            Label: matchValue_1,
        }))), delay(() => append(singleton(createElement(InformationAlert, {
            Label: t("tool.create_tool_validation_info"),
        })), delay(() => {
            let Header;
            return append(singleton(createElement(FormSection, (Header = t("general.master_data"), {
                Content: toList(delay(() => append(isFeatureEnabled(new Feature(5, [])) ? (!props.IsEdit ? singleton(createElement(FormMultipleImageSection, {
                    ComponentState: componentState,
                    SelectedFiles: props.ToolImages,
                    SetSelectedFile: (files) => {
                        props.Dispatch(new Msg(33, [files]));
                    },
                })) : empty()) : empty(), delay(() => {
                    let dependencies_1;
                    return append(singleton((dependencies_1 = [props.ToolForm.Manufacturer, props.Manufacturers, () => FormState__isValid(props.FormState), componentState], reactApi.useMemo(() => createElement(AutoSuggestInput, {
                        ComponentState: componentState,
                        Label: t("tool.manufacturer"),
                        OnChange: (arg) => {
                            props.Dispatch(new Msg(0, [arg]));
                        },
                        Suggestions: props.Manufacturers,
                        TestId: "create-tool-form-manufacturer",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "manufacturer")),
                        Value: props.ToolForm.Manufacturer,
                    }), dependencies_1))), delay(() => append(singleton(createElement(Input, {
                        ComponentState: componentState,
                        Label: t("tool.model"),
                        OnChange: (arg_1) => {
                            props.Dispatch(new Msg(2, [arg_1]));
                        },
                        TestId: "create-tool-form-model",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "model")),
                        Value: props.ToolForm.Model,
                    })), delay(() => append(singleton(createElement(Input, {
                        ComponentState: componentState,
                        Label: t("tool.serial_number"),
                        OnChange: (arg_2) => {
                            props.Dispatch(new Msg(3, [arg_2]));
                        },
                        TestId: "create-tool-form-serial-number",
                        Value: props.ToolForm.SerialNumber,
                    })), delay(() => append(singleton(createElement(Input, {
                        ComponentState: componentState,
                        Label: t("tool.displayname"),
                        OnChange: (arg_3) => {
                            props.Dispatch(new Msg(1, [arg_3]));
                        },
                        TestId: "create-tool-form-display-name",
                        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "displayName")),
                        Value: props.ToolForm.DisplayName,
                    })), delay(() => {
                        let buName;
                        return append(isFeatureEnabled(new Feature(17, [])) ? ((props.AccountSettings.BusinessUnitsEnabled && !props.IsEdit) ? ((props.IsPresetFromParent && (props.ToolForm.BusinessUnitId != null)) ? ((buName = defaultArg(map((_arg_2) => _arg_2.Name, tryFind((bu) => equals(bu.Id, props.ToolForm.BusinessUnitId), props.BusinessUnits)), ""), singleton(createElement(Input, {
                            ComponentState: "disabled",
                            Label: t("business_units.business_unit"),
                            OnChange: (value_6) => {
                            },
                            TestId: "create-tool-form-business-unit",
                            Value: buName,
                        })))) : singleton(createElement(BusinessUnitSelect, {
                            BusinessUnits: props.BusinessUnits,
                            FormState: props.FormState,
                            OnChange: (value_7) => {
                                props.Dispatch(new Msg(19, [value_7]));
                            },
                            SelectedBusinessUnitId: unwrap(props.ToolForm.BusinessUnitId),
                        }))) : empty()) : empty(), delay(() => {
                            let Label_5, Value_4;
                            return append(singleton(createElement(Input, (Label_5 = t("tool.inventory_number"), (Value_4 = ((props.CustomerConfiguration.InventoryConfiguration.InventoryNumberAutomaticIncrease && isNullOrWhiteSpace(props.ToolForm.InventoryNumber)) ? t("settings.inventory.inventory_number_placeholder") : props.ToolForm.InventoryNumber), {
                                ComponentState: props.CustomerConfiguration.InventoryConfiguration.InventoryNumberAutomaticIncrease ? "disabled" : componentState,
                                Label: unwrap(Label_5),
                                OnChange: (arg_4) => {
                                    props.Dispatch(new Msg(4, [arg_4]));
                                },
                                TestId: "create-tool-form-inventory-number",
                                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "inventoryNumber")),
                                Value: Value_4,
                            })))), delay(() => {
                                let Label_6, Options, NoOptionsMessage, Value_6, storage_2;
                                const storage = tryFind((s) => (StorageId__get_unwrap(s.Id) === props.ToolForm.StorageId), props.Storages);
                                return append(!props.IsEdit ? singleton(createElement(Select, (Label_6 = t("general.storage"), (Options = map_1((storage_1) => ({
                                    label: Storage__get_DisplayName(storage_1),
                                    value: storage_1.Id,
                                }), filter((s_2) => {
                                    const matchValue_2 = props.ToolForm.BusinessUnitId;
                                    if (matchValue_2 == null) {
                                        return true;
                                    }
                                    else {
                                        const businessUnitId = matchValue_2;
                                        return defaultArg(map((id) => (id === businessUnitId), map(BusinessUnitId__get_unwrap, s_2.BusinessUnitId)), false);
                                    }
                                }, filter((s_1) => Permissions_allowsInStorage(permissions, new Permission(1, []), props.UserData.UserId, unwrapStorageId(s_1.Id), s_1.AssignedUserIds), props.Storages))), (NoOptionsMessage = t("tool.no_storage_found"), (Value_6 = ((storage == null) ? undefined : ((storage_2 = storage, {
                                    label: Storage__get_DisplayName(storage_2),
                                    value: storage_2.Id,
                                }))), {
                                    ComponentState: props.IsPresetFromParent ? "disabled" : componentState,
                                    IsClearable: false,
                                    Label: unwrap(Label_6),
                                    NoOptionsMessage: NoOptionsMessage,
                                    OnChange: (s_3) => {
                                        props.Dispatch(new Msg(5, [value_22(s_3)]));
                                    },
                                    Options: Options,
                                    PlaceholderKey: "",
                                    TestId: "create-tool-form-select",
                                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "storage")),
                                    Value: unwrap(Value_6),
                                })))))) : empty(), delay(() => append(singleton(createElement(Input, {
                                    ComponentState: componentState,
                                    Label: t("tool.storage_space"),
                                    OnChange: (arg_5) => {
                                        props.Dispatch(new Msg(6, [arg_5]));
                                    },
                                    TestId: "create-tool-form-storage-space",
                                    Value: props.ToolForm.StorageSpace,
                                })), delay(() => append(singleton(createElement(TextArea, {
                                    ComponentState: componentState,
                                    Label: t("general.comment"),
                                    OnChange: (arg_6) => {
                                        props.Dispatch(new Msg(7, [arg_6]));
                                    },
                                    TestId: "create-tool-form-comment",
                                    Value: props.ToolForm.Comment,
                                })), delay(() => {
                                    let elems_1;
                                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], ["data-test-id", "tool-form-categories"], (elems_1 = toList(delay(() => {
                                        const deepestSelectedIds = Hierarchy_keepDeepestCategories(props.Labels, map_1((arg_7) => (new LabelId(parse(arg_7))), props.ToolForm.CategoryIds));
                                        const treeOptions = map_1((tupledArg) => {
                                            const l = tupledArg[0];
                                            return {
                                                color: l.ColorHex,
                                                label: concat(Array((tupledArg[1] * 4) + 1).join(" "), ...l.Name),
                                                value: l.Id,
                                            };
                                        }, Hierarchy_buildTreeOrderedList(props.Labels));
                                        return append(singleton(createElement(MultiSelectWithColor, {
                                            ComponentState: componentState,
                                            IsClearable: true,
                                            Label: t("tool.label"),
                                            NoOptionsMessage: "",
                                            OnChange: (arg_8) => {
                                                props.Dispatch(new Msg(10, [arg_8]));
                                            },
                                            Options: filter((o) => !contains(o.value, deepestSelectedIds, {
                                                Equals: equals,
                                                GetHashCode: (x) => (safeHash(x) | 0),
                                            }), treeOptions),
                                            PlaceholderKey: "",
                                            TestId: "tool-form-categories-select",
                                            Value: map_1((l_2) => ({
                                                color: l_2.ColorHex,
                                                label: Hierarchy_getDisplayName(props.Labels, l_2),
                                                value: l_2.Id,
                                            }), choose((id_1) => tryFind((l_1) => equals(l_1.Id, id_1), props.Labels), deepestSelectedIds)),
                                        })), delay(() => singleton(createElement(TextButton, {
                                            ComponentState: componentState,
                                            Label: t("settings.create_new_label"),
                                            OnClick: () => {
                                                setIsNewCateogoryDialogOpen(true);
                                            },
                                            TestId: "add-new-category-button",
                                            Variant: "default",
                                        }))));
                                    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                                }))))));
                            }));
                        }));
                    }))))))));
                })))),
                Header: Header,
                Id: "master_data",
            }))), delay(() => {
                let Header_1;
                return append(singleton(createElement(FormSection, (Header_1 = t("general.qr_codes"), {
                    Content: singleton_1(createElement(QrCodeTable, {
                        OnAssignQrCode: (arg_9) => {
                            props.Dispatch(new Msg(12, [arg_9]));
                        },
                        OnDeleteQrCodes: (arg_10) => {
                            props.Dispatch(new Msg(25, [arg_10]));
                        },
                        QrCodes: props.ToolForm.QRCodeIds,
                        Storage: unwrap(map((s_5) => (new StorageAccess(StorageId__get_unwrap(s_5.Id), s_5.AssignedUserIds)), tryFind((s_4) => (StorageId__get_unwrap(s_4.Id) === props.ToolForm.StorageId), props.Storages))),
                        UserData: props.UserData,
                    })),
                    Header: Header_1,
                    Id: "qr_codes",
                }))), delay(() => {
                    let Header_2;
                    return append(singleton(createElement(FormSection, (Header_2 = t("general.appointments"), {
                        Content: ofArray([createElement(DatePicker, {
                            ComponentState: componentState,
                            IsClearable: true,
                            Label: t("tool.last_check"),
                            OnChange: (date) => {
                                props.Dispatch(new Msg(8, [date]));
                            },
                            TestId: "tool-form-last-check",
                            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "lastInspectionDate")),
                            Value: unwrap(props.LastInspectionDate),
                        }), createElement(DatePicker, {
                            ComponentState: componentState,
                            IsClearable: true,
                            Label: t("tool.next_inspection"),
                            OnChange: (date_1) => {
                                props.Dispatch(new Msg(9, [date_1]));
                            },
                            TestId: "tool-form-next-check",
                            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "nextInspectionDate")),
                            Value: unwrap(props.NextInspectionDate),
                        })]),
                        Header: Header_2,
                        Id: "appointments",
                    }))), delay(() => {
                        let Header_3;
                        return append(isCommercialDataVisible ? singleton(createElement(FormSection, (Header_3 = t("tool.commercial_data"), {
                            Content: ofArray([createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.supplier"),
                                OnChange: (arg_11) => {
                                    props.Dispatch(new Msg(13, [arg_11]));
                                },
                                TestId: "tool-form-supplier",
                                Value: props.ToolForm.CommercialData.Supplier,
                            }), createElement(Input, {
                                ComponentState: componentState,
                                Label: t("general.supplier_article_number"),
                                OnChange: (arg_12) => {
                                    props.Dispatch(new Msg(14, [arg_12]));
                                },
                                TestId: "tool-form-article-number",
                                Value: props.ToolForm.CommercialData.SupplierArticleNumber,
                            }), createElement(CurrencyInput, {
                                ComponentState: componentState,
                                Currency: props.CustomerConfiguration.Currency,
                                Label: t("general.purchase_price"),
                                OnChange: (price) => {
                                    props.Dispatch(new Msg(15, [price]));
                                },
                                TestId: "tool-form-purchase-price",
                                Value: unwrap(props.ToolForm.CommercialData.PurchasePrice),
                            }), createElement(DatePicker, {
                                ComponentState: componentState,
                                IsClearable: true,
                                Label: t("general.purchase_date"),
                                OnChange: (date_2) => {
                                    props.Dispatch(new Msg(16, [date_2]));
                                },
                                TestId: "tool-form-purchase-date",
                                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "purchaseDate")),
                                Value: unwrap(props.PurchaseDate),
                            }), createElement(DatePicker, {
                                ComponentState: componentState,
                                IsClearable: true,
                                Label: t("general.gurantee_date"),
                                OnChange: (date_3) => {
                                    props.Dispatch(new Msg(17, [date_3]));
                                },
                                TestId: "tool-form-gurantee-date",
                                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "warrantyDate")),
                                Value: unwrap(props.WarrantyDate),
                            }), createElement(TextArea, {
                                ComponentState: componentState,
                                Label: t("general.comment"),
                                OnChange: (arg_13) => {
                                    props.Dispatch(new Msg(18, [arg_13]));
                                },
                                TestId: "tool-form-commercial-data-comment",
                                Value: props.ToolForm.CommercialData.Comment,
                            })]),
                            Header: Header_3,
                            Id: "commercial_data",
                        }))) : empty(), delay(() => {
                            let Header_4;
                            return append(props.IsCustomPropertiesEnabled ? singleton(createElement(FormSection, (Header_4 = t("tool.custom_properties"), {
                                Content: singleton_1(createElement(NewInventoryCustomProperties, {
                                    Currency: props.CustomerConfiguration.Currency,
                                    CustomProperties: props.ToolForm.CustomProperties,
                                    FormState: props.FormState,
                                    LabelIds: Hierarchy_getAllCategoryIdsInHierarchy(props.Labels, map_1((arg_15) => (new LabelId(parse(arg_15))), props.ToolForm.CategoryIds)),
                                    OnSetCustomProperty: (arg_14) => {
                                        props.Dispatch(new Msg(11, [arg_14]));
                                    },
                                    PropertyConfigurations: props.PropertyConfigurations,
                                })),
                                Header: Header_4,
                                Id: "custom_properties",
                            }))) : empty(), delay(() => {
                                let matchValue_3;
                                return append((matchValue_3 = props.ToolForm.PrinzingSpecificFields, (matchValue_3 == null) ? (empty()) : singleton(createElement(PrinzingSpecificForm, {
                                    ComponentState: componentState,
                                    Dispatch: props.Dispatch,
                                    FormState: props.FormState,
                                    PrinzingSpecific: matchValue_3,
                                }))), delay(() => {
                                    let matchValue_4;
                                    return append((matchValue_4 = FormState__getValidation(props.FormState, t, "global"), (matchValue_4 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                                        Label: matchValue_4,
                                    }))), delay(() => {
                                        let elems_2;
                                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_2 = [createElement(Button, {
                                            ComponentState: componentState,
                                            Label: t("general.save"),
                                            OnClick: props.OnSave,
                                            TestId: "tool-form-save-button",
                                            Variant: "primary",
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function EditToolView(props) {
    let elems_1, elems, Label;
    const patternInput = useTranslation();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initEditView(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, props.ToolId], [props.ToolId]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const matchValue = state_1.ToolForm;
    const matchValue_1 = state_1.Storages;
    const matchValue_2 = state_1.Labels;
    const matchValue_3 = state_1.PropertyConfigurations;
    const matchValue_4 = state_1.IsCustomPropertiesEnabled;
    const matchValue_5 = state_1.BusinessUnits;
    const matchValue_6 = state_1.AccountSettings;
    let matchResult, accountSettings, businessUnits, isPropertyConfigurationsEnabled, labels, propertyConfigurations, storages, tool;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_6.fields[0];
        businessUnits = matchValue_5.fields[0];
        isPropertyConfigurationsEnabled = matchValue_4.fields[0];
        labels = matchValue_2.fields[0];
        propertyConfigurations = matchValue_3.fields[0];
        storages = matchValue_1.fields[0];
        tool = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3", "flex"])], (elems = [createElement(TextButton, (Label = patternInput[0]("general.back"), {
                ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                Icon: Arrow_Left_1(),
                Label: Label,
                OnClick: () => {
                    RouterModule_nav(ofArray(["tools", unwrapToolId(props.ToolId) + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                TestId: "tools-new-back-to-overview-button",
                Variant: "default",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PageHeader, {
                Text: "tool.edit_tool",
            }), createElement(ToolForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                IsCustomPropertiesEnabled: isPropertyConfigurationsEnabled && !isEmpty(propertyConfigurations),
                IsEdit: true,
                IsPresetFromParent: false,
                Labels: labels,
                LastInspectionDate: unwrap(state_1.LastInspectionDate),
                Manufacturers: state_1.Manufacturers,
                NextInspectionDate: unwrap(state_1.NextInspectionDate),
                OnSave: () => {
                    dispatch(new Msg(22, []));
                },
                PropertyConfigurations: propertyConfigurations,
                PurchaseDate: unwrap(state_1.PurchaseDate),
                Storages: storages,
                ToolForm: tool,
                ToolImages: state_1.ToolImages,
                UserData: state_1.UserData,
                WarrantyDate: unwrap(state_1.WarrantyDate),
                WithAnchorMenu: true,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

export function NewToolView(props) {
    let elems_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNewToolView, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const matchValue = state_1.ToolForm;
    const matchValue_1 = state_1.Storages;
    const matchValue_2 = state_1.Labels;
    const matchValue_3 = state_1.PropertyConfigurations;
    const matchValue_4 = state_1.IsCustomPropertiesEnabled;
    const matchValue_5 = state_1.BusinessUnits;
    const matchValue_6 = state_1.AccountSettings;
    let matchResult, accountSettings, businessUnits, isPropertyConfigurationsEnabled, labels, propertyConfigurations, storages, tool;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_6.fields[0];
        businessUnits = matchValue_5.fields[0];
        isPropertyConfigurationsEnabled = matchValue_4.fields[0];
        labels = matchValue_2.fields[0];
        propertyConfigurations = matchValue_3.fields[0];
        storages = matchValue_1.fields[0];
        tool = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = toList(delay(() => {
                let elems, Label;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3", "flex"])], (elems = [createElement(TextButton, (Label = t("general.back_to_overview"), {
                    ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                    Icon: Arrow_Left_1(),
                    Label: Label,
                    OnClick: () => {
                        RouterModule_nav(singleton_1("tools" + RouterModule_encodeQueryString(getQueryParams(undefined))), 1, 1);
                    },
                    TestId: "tools-new-back-to-overview-button",
                    Variant: "default",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(singleton(createElement(PageHeader, {
                    Text: "tool.create_new_tool",
                })), delay(() => append(singleton(createElement(ToolForm, {
                    AccountSettings: accountSettings,
                    BusinessUnits: businessUnits,
                    CustomerConfiguration: props.CustomerConfiguration,
                    Dispatch: dispatch,
                    FormState: state_1.FormState,
                    IsCustomPropertiesEnabled: isPropertyConfigurationsEnabled && !isEmpty(propertyConfigurations),
                    IsEdit: false,
                    IsPresetFromParent: false,
                    Labels: labels,
                    LastInspectionDate: unwrap(state_1.LastInspectionDate),
                    Manufacturers: state_1.Manufacturers,
                    NextInspectionDate: unwrap(state_1.NextInspectionDate),
                    OnSave: () => {
                        dispatch(new Msg(21, []));
                    },
                    PropertyConfigurations: propertyConfigurations,
                    PurchaseDate: unwrap(state_1.PurchaseDate),
                    Storages: storages,
                    ToolForm: tool,
                    ToolImages: state_1.ToolImages,
                    UserData: state_1.UserData,
                    WarrantyDate: unwrap(state_1.WarrantyDate),
                    WithAnchorMenu: true,
                })), delay(() => {
                    let Steps;
                    return isCreateInventoryFormOnboardingTourPhase() ? singleton(createElement(TourGuide, (Steps = ofArray([new TourStep("[data-test-id=\'create-tool-form-manufacturer\']", t("onboarding.tour.form_tour_step_manufacturer_title"), reactElement("div", {
                        children: t("onboarding.tour.form_tour_step_manufacturer_content"),
                    }), "bottom", false), new TourStep("[data-test-id=\'create-tool-form-inventory-number\']", t("onboarding.tour.form_tour_step_inventory_number_title"), reactElement("div", {
                        children: t("onboarding.tour.form_tour_step_inventory_number_content"),
                    }), "bottom", false), new TourStep("[data-test-id=\'create-tool-form-select\']", t("onboarding.tour.form_tour_step_storage_title"), reactElement("div", {
                        children: t("onboarding.tour.form_tour_step_storage_content"),
                    }), "bottom", false), new TourStep("[data-test-id=\'tool-form-categories\']", t("onboarding.tour.form_tour_step_categories_title"), reactElement("div", {
                        children: t("onboarding.tour.form_tour_step_categories_content"),
                    }), "bottom", false), new TourStep("[data-test-id=\'tool-form-save-button\']", t("onboarding.tour.form_tour_step_save_title"), reactElement("div", {
                        children: t("onboarding.tour.form_tour_step_save_content"),
                    }), "top", false)]), {
                        IsRunning: true,
                        Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                        OnFinish: () => {
                            dispatch(new Msg(38, []));
                        },
                        OnSkip: () => {
                            dispatch(new Msg(39, []));
                        },
                        ScrollFirstStep: false,
                        Steps: Steps,
                    }))) : empty();
                }))))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

export function CopyNewToolView(props) {
    let elems_1, elems, Label;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initCopyNewTool(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.ToolId, props.UserData], [props.ToolId]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.ToolForm;
    const matchValue_1 = state_1.Storages;
    const matchValue_2 = state_1.Labels;
    const matchValue_3 = state_1.PropertyConfigurations;
    const matchValue_4 = state_1.IsCustomPropertiesEnabled;
    const matchValue_5 = state_1.BusinessUnits;
    const matchValue_6 = state_1.AccountSettings;
    let matchResult, accountSettings, businessUnits, isCustomPropertiesEnabled, labels, propertyConfigurations, storages, tool;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_6.fields[0];
        businessUnits = matchValue_5.fields[0];
        isCustomPropertiesEnabled = matchValue_4.fields[0];
        labels = matchValue_2.fields[0];
        propertyConfigurations = matchValue_3.fields[0];
        storages = matchValue_1.fields[0];
        tool = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-3", "flex"])], (elems = [createElement(TextButton, (Label = patternInput_1[0]("general.back"), {
                ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                Icon: Arrow_Left_1(),
                Label: Label,
                OnClick: () => {
                    RouterModule_nav(ofArray(["tools", unwrapToolId(props.ToolId) + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
                },
                TestId: "tools-new-back-to-overview-button",
                Variant: "default",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PageHeader, {
                Text: "tool.copy_tool",
            }), createElement(ToolForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                CustomerConfiguration: props.CustomerConfiguration,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                IsCustomPropertiesEnabled: isCustomPropertiesEnabled && !isEmpty(propertyConfigurations),
                IsEdit: false,
                IsPresetFromParent: false,
                Labels: labels,
                LastInspectionDate: unwrap(state_1.LastInspectionDate),
                Manufacturers: state_1.Manufacturers,
                NextInspectionDate: unwrap(state_1.NextInspectionDate),
                OnSave: () => {
                    dispatch(new Msg(21, []));
                },
                PropertyConfigurations: propertyConfigurations,
                PurchaseDate: unwrap(state_1.PurchaseDate),
                Storages: storages,
                ToolForm: tool,
                ToolImages: state_1.ToolImages,
                UserData: state_1.UserData,
                WarrantyDate: unwrap(state_1.WarrantyDate),
                WithAnchorMenu: true,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

export function NewToolModalView(props) {
    let elems, matchValue, matchValue_1, matchValue_2, matchValue_3, matchValue_4, matchValue_5, matchValue_6, storages_1, matchValue_8, storageId, elems_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => initNewToolModalView(props.UserData, props.OnSuccessCallback, props.IsSelectedStorageIdNeeded, props.StorageId, props.BusinessUnitId), update_1, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    return createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (props.IsSelectedStorageIdNeeded && (props.StorageId == null)) ? reactElement("div", createObj(ofArray([["className", join(" ", ["px-5"])], (elems = [createElement(WarningAlert, {
            Label: t("set.add_tool_dialog.storage_not_selected_information"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))) : ((matchValue = state_1.ToolForm, (matchValue_1 = state_1.Storages, (matchValue_2 = state_1.Labels, (matchValue_3 = state_1.PropertyConfigurations, (matchValue_4 = state_1.IsCustomPropertiesEnabled, (matchValue_5 = state_1.BusinessUnits, (matchValue_6 = state_1.AccountSettings, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : ((matchValue_1.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : ((matchValue_3.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : ((matchValue_4.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : ((matchValue_5.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : ((matchValue_6.tag === 0) ? createElement(Skeleton, {
            Variant: "normal",
        }) : ((storages_1 = ((matchValue_8 = props.StorageId, (matchValue_8 == null) ? matchValue_1.fields[0] : ((storageId = matchValue_8, filter((storage) => equals(storage.Id, storageId), matchValue_1.fields[0]))))), reactElement("div", createObj(ofArray([["className", join(" ", ["pb-5"])], (elems_1 = [createElement(ToolForm, {
            AccountSettings: matchValue_6.fields[0],
            BusinessUnits: matchValue_5.fields[0],
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: dispatch,
            FormState: state_1.FormState,
            IsCustomPropertiesEnabled: matchValue_4.fields[0] && !isEmpty(matchValue_3.fields[0]),
            IsEdit: false,
            IsPresetFromParent: props.StorageId != null,
            Labels: matchValue_2.fields[0],
            LastInspectionDate: unwrap(state_1.LastInspectionDate),
            Manufacturers: state_1.Manufacturers,
            NextInspectionDate: unwrap(state_1.NextInspectionDate),
            OnSave: () => {
                dispatch(new Msg(21, []));
            },
            PropertyConfigurations: matchValue_3.fields[0],
            PurchaseDate: unwrap(state_1.PurchaseDate),
            Storages: storages_1,
            ToolForm: matchValue.fields[0],
            ToolImages: state_1.ToolImages,
            UserData: state_1.UserData,
            WarrantyDate: unwrap(state_1.WarrantyDate),
            WithAnchorMenu: false,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))))))))))))))))),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: t("tool.create_new_tool"),
    });
}

